import { Checkbox, Drawer, Flex, Link, Text } from '@servicetitan/anvil2';
import { useState } from 'react';
import { TurnsDisclosureText } from './TurnsDisclosureText';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

export interface TurnsCoapplicationDisclosureProps {
    onChange: (agreed: boolean) => void;
}

export const TurnsCoapplicationDisclosure = ({ onChange }: TurnsCoapplicationDisclosureProps) => {
    const [showTerms, setShowTerms] = useState(false);
    const { turnsCoapplicationDisclosureText } = useProviderConfig();

    return (
        <Flex direction="row">
            <Checkbox onChange={(e, state) => onChange(state?.checked ?? false)} />
            <Text>
                {turnsCoapplicationDisclosureText}{' '}
                <Link onClick={() => setShowTerms(true)}>View terms</Link>
            </Text>
            {showTerms && (
                <Drawer open onClose={() => setShowTerms(false)}>
                    <Drawer.Header>Turns Financing Terms</Drawer.Header>
                    <Drawer.Content>
                        <TurnsDisclosureText />
                    </Drawer.Content>
                </Drawer>
            )}
        </Flex>
    );
};
